// extracted by mini-css-extract-plugin
export default {"content":"Settings_content__SGly-"};